export default "__VITE_ASSET__CiAv7eV1__"